import { DEFAULT_FILTERS } from '@calendar/lib/constants';
import { type FilterState } from '@calendar/components/calendar-filters';

// Extend Window interface to include our preset filters
declare global {
  interface Window {
    curtisCalendarPresetFilters?: Partial<FilterState>;
  }
}

export default function ViewNone({ setFilters }: { setFilters: (filters: FilterState) => void }) {
  const handleReset = () => {
    const resetFilters = { ...DEFAULT_FILTERS };
    
    // Preserve preset filters from being reset
    if (window.curtisCalendarPresetFilters) {
      Object.assign(resetFilters, window.curtisCalendarPresetFilters);
    }
    
    setFilters(resetFilters);
  };

  return (
    <div className="app--calendar__container empty">
      <div className="message">
        No events match your current selections.
      </div>

      <button data-style="default" className="button" onClick={handleReset}>Show all Upcoming Events</button>
    </div>
  );
}
